export const dynamicPageRoute = {
  cart: 'Checkout.cart',
  category: 'Category.view',
  wishlist: 'Account.wishlists',
  accountProfile: 'Account.profile',
  checkout: 'Checkout.checkout',
  account: 'Account.index',
};
